import Vue from 'vue'
import moment from 'moment';

Vue.filter('timeStampToHuman', function (value) {
    let data_objeto = moment(value);
    return data_objeto.format('DD/MM/YYYY HH:mm:ss');
});

Vue.filter('timeStampToHourMin', function (value) {
    let data_objeto = moment(value);
    return data_objeto.format('HH:mm');
});

Vue.filter('integerToMoney2', function (value) {
    let val = (value/1).toFixed(2).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

Vue.filter('timeStampToDate', function (value) {
    let data_objeto = moment(value);
    return data_objeto.format('DD/MM/YYYY');
});

Vue.filter('statusNotification', function (value) {
    if (value === 1) {
        return 'Pendente'
    } else if (value === 2) {
        return 'Notificado'
    } else if (value === 3) {
        return 'Pago'
    } else if (value === 4) {
        return 'Autuado'
    } else if (value === 5) {
        return 'Cancelado'
    } else if (value === 6) {
        return 'Desconsiderado'
    }
});

Vue.filter('integerToMoney', function (value) {
    return value / 100;
});

Vue.filter('moneyToInteger', function (value) {
    return value * 100;
});

Vue.filter('capitalize', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.filter('activationTypeToText', function (value) {
    switch (value) {
        case 1:
            return 'Normal';
        case 2:
            return 'Notificação';
        case 3:
            return 'Aviso';
        case 4:
            return 'Autuado';
        default:
            return value;
    }
});